/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */


import {Directive, ElementRef, Renderer2, forwardRef} from '@angular/core';

import {ControlValueAccessor, NG_VALUE_ACCESSOR} from './control_value_accessor';

export const /** @type {?} */ CHECKBOX_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => CheckboxControlValueAccessor),
  multi: true,
};
/**
 * The accessor for writing a value and listening to changes on a checkbox input element.
 * 
 *  ### Example
 *  ```
 *  <input type="checkbox" name="rememberLogin" ngModel>
 *  ```
 * 
 *  \@stable
 */
export class CheckboxControlValueAccessor implements ControlValueAccessor {
  onChange = (_: any) => {};
  onTouched = () => {};
/**
 * @param {?} _renderer
 * @param {?} _elementRef
 */
constructor(private _renderer: Renderer2,
private _elementRef: ElementRef) {}
/**
 * @param {?} value
 * @return {?}
 */
writeValue(value: any): void {
    this._renderer.setProperty(this._elementRef.nativeElement, 'checked', value);
  }
/**
 * @param {?} fn
 * @return {?}
 */
registerOnChange(fn: (_: any) => {}): void { this.onChange = fn; }
/**
 * @param {?} fn
 * @return {?}
 */
registerOnTouched(fn: () => {}): void { this.onTouched = fn; }
/**
 * @param {?} isDisabled
 * @return {?}
 */
setDisabledState(isDisabled: boolean): void {
    this._renderer.setProperty(this._elementRef.nativeElement, 'disabled', isDisabled);
  }
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
  selector:
      'input[type=checkbox][formControlName],input[type=checkbox][formControl],input[type=checkbox][ngModel]',
  host: {'(change)': 'onChange($event.target.checked)', '(blur)': 'onTouched()'},
  providers: [CHECKBOX_VALUE_ACCESSOR]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: Renderer2, },
{type: ElementRef, },
];
}

function CheckboxControlValueAccessor_tsickle_Closure_declarations() {
/** @type {?} */
CheckboxControlValueAccessor.decorators;
/**
 * @nocollapse
 * @type {?}
 */
CheckboxControlValueAccessor.ctorParameters;
/** @type {?} */
CheckboxControlValueAccessor.prototype.onChange;
/** @type {?} */
CheckboxControlValueAccessor.prototype.onTouched;
/** @type {?} */
CheckboxControlValueAccessor.prototype._renderer;
/** @type {?} */
CheckboxControlValueAccessor.prototype._elementRef;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}



// WEBPACK FOOTER //
// ../../../../packages/forms/src/directives/checkbox_value_accessor.ts